<template>
  <div v-if="pattern === 1" :id="appId" :class="{'pattern1': isShow}" class="circle"></div>
  <div v-else-if="pattern === 2" :id="appId" :class="{'pattern2': isShow}" class="circle"></div>
  <div v-else :id="appId" :class="{'pattern3': isShow}" class="circle"></div>
</template>

<script>
export default {
  name: 'Light',
  props: {
    appId: String
  },
  data() {
    return {
      pattern: 1,
      sleepTime: 0,
      isShow: false
    }
  },

  created: function() {
    this.decidePattern();
    this.showLight();
  },

  methods: {
    decidePattern: function() {
      // MEMO: appIDの先頭文字で何を出すか分ける
      let firstChar = this.appId.charAt(0);

      // 正規表現を定義する
      if (this.$parent.rNum.test(firstChar)) {
        this.pattern = 1;
        this.sleepTime = 650
      } else if (this.$parent.rUpper.test(firstChar)) {
        this.pattern = 2;
        this.sleepTime = 700
      } else {
        this.pattern = 3;
        this.sleepTime = 600
      }
    },

    showLight: function() {
      this.isShow = true;
      setTimeout(() => {
        this.isShow = false;
      }, this.sleepTime);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.circle {
  width: 100%;
  height: 100%; 
  border-radius: 50%;
  background: #6d6e74;
  margin: 0 auto;
  opacity: 0;
}

.pattern1 {
  animation: fadeinout1 0.65s linear forwards;
  opacity: 0;
  will-change: transform;
}

.pattern2 {
  animation: fadeinout2 0.7s linear forwards;
  opacity: 0;
  will-change: transform;
}

.pattern3 {
  animation: fadeinout 0.6s linear forwards;
}

@keyframes fadeinout {
  50% { opacity: 1; }
}

@keyframes fadeinout1 {
  50% { opacity: 0.9; }
}

@keyframes fadeinout2 {
  50% { opacity: 0.6; }
}
</style>
